export const PAYERS: Record<string, string> = {
    "aetna": "Aetna",
    "anthem": "Anthem",
    "bcbs": "Health Care Service Corporation",
    "bs": "Blue Shield of California",
    "cigna": "Cigna",
    "cms": "CMS", // Centers for Medicare & Medicaid Services
    "healthnet": "Health Net",
    "humana": "Humana",
    "united": "UnitedHealthcare",
    "kaiser": "Kaiser Permanente",
    "molina": "Molina Healthcare",
    "wellcare": "WellCare Health Plans",
    "oscar": "Oscar Health",
    "metroplus": "MetroPlus Health Plan",
};

/**
 * Convert API payer name (as stored in Elasticsearch) to display name.
 * Similar to how STATE_CODE_TO_NAME works for states.
 * 
 * @param apiName - The payer name as stored in Elasticsearch (e.g., "aetna")
 * @returns Display name for the payer (e.g., "Aetna")
 */
export function getPayerDisplayName(apiName: string): string {
    if (!apiName) {
        return "";
    }
    
    // Normalize the API name (lowercase, strip whitespace)
    const normalized = apiName.toLowerCase().trim();
    
    // Check if we have a mapping
    if (normalized in PAYERS) {
        return PAYERS[normalized];
    }
    
    // If no mapping found, capitalize first letter of each word as fallback
    return apiName
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
